import React, { useContext, useCallback, useEffect, useState } from 'react';
import RegisterMachine from 'components/RegisterMachine/RegisterMachine';
import UserContext from 'pages/Login/UserContext';
import './RegisterModal.scss';
import { useTranslation } from 'react-i18next';
import LogoCatbears from 'components/LogoCatbears/LogoCatbears';

const RegisterModal = ({
  isOpen,
  onClose,
  onSuccess,
}) => {
  const { user } = useContext(UserContext);
  const { t } = useTranslation();
  const [currentMode, setCurrentMode] = useState('register');
  
  // Reset mode when modal opens
  useEffect(() => {
    if (isOpen) {
      setCurrentMode('register');
    }
  }, [isOpen]);

  const handleSuccess = useCallback(() => {
    if (onSuccess) {
      onSuccess();
    }
    if (onClose) {
      onClose();
    }
  }, [onSuccess, onClose]);

  useEffect(() => {
    if (isOpen) {
      try { document.body.classList.add('hide-global-notification'); } catch(_) {}
    }
    return () => {
      try { document.body.classList.remove('hide-global-notification'); } catch(_) {}
    };
  }, [isOpen]);

  // If user is not a guest, close the modal (use useEffect to avoid updating state during render)
  useEffect(() => {
    if (isOpen && user && !user.isGuest) {
      handleSuccess();
    }
  }, [isOpen, user, handleSuccess]);

  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      // Don't allow closing by clicking background - user must register
    }
  };

  return (
    <div className="register-modal-overlay" onClick={handleOverlayClick} role="dialog" aria-modal="true">
      <div className="register-modal-content">
        <div className="register-modal-closeWrap">
          <button
            className="register-modal-close"
            onClick={onClose}
            aria-label="close"
          >
            <img src="/assets/icons/iconX.svg" alt="close" />
          </button>
        </div>
        <div className="register-modal-body">
          <div className="register-modal-header">
            <LogoCatbears isSoundSwitch={false} isFeedbackBtn={false} hideLogoOnMobile={false} isCentered={false} isTapToLandingPage={false} isFixed={false} />
            <div className="register-modal-title">
              {currentMode === 'register' && t('loginFlow.registerToCatbears_title')}
              {currentMode === 'login' && t('loginFlow.loginToCatbears_title')}
              {currentMode === 'forgot' && t('loginFlow.forgotPasswordTitle')}
            </div>
            <div className="register-modal-subtitle">
              {currentMode === 'register' && t('loginFlow.registerToCatbears_subtitle')}
              {currentMode === 'login' && t('loginFlow.loginToCatbears_subtitle')}
              {currentMode === 'forgot' && t('loginFlow.forgotPasswordSubtitle')}
            </div>
          </div>
          <RegisterMachine
            onSuccess={handleSuccess}
            initialMode="register"
            onModeChange={setCurrentMode}
          />
        </div>
      </div>
    </div>
  );
};

export default RegisterModal;

